import { render, staticRenderFns } from "./InvitationComponent.vue?vue&type=template&id=3318683c&scoped=true&"
import script from "./InvitationComponent.vue?vue&type=script&lang=js&"
export * from "./InvitationComponent.vue?vue&type=script&lang=js&"
import style0 from "./InvitationComponent.vue?vue&type=style&index=0&id=3318683c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3318683c",
  null
  
)

export default component.exports